import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async (data: {
  // carBrandId?: string;
  // carModelId?: string;
  // manufacturerCountry?: string;
  // steering?: string;
  page?: number;
  limit?: number;
}) => {
  const res = await httpRequest.get(`/api/non_collateral_vehicle`, data);
  return res;
};

export const get = async (data: { id: string }) => {
  const res = await httpRequest.get(`/api/non_collateral_vehicle/${data.id}/detail`, data);
  return res;
};

export const update = async (
  data: {
    carBrandId?: undefined;
    carModelId?: undefined;
    manufacturerCountry?: undefined;
    steering?: undefined;
  },
  id: string
) => {
  const res = await httpRequest.put(`/api/non_collateral_vehicle/${id}/update`, {
    carBrandId: data.carBrandId,
    carModelId: data.carModelId,
    manufacturerCountry: data.manufacturerCountry,
    steering: data.steering,
  });
  return res;
};

export const create = async (data: {
  carBrandId?: undefined;
  carModelId?: undefined;
  manufacturerCountry?: undefined;
  steering?: undefined;
}) => {
  const res = await httpRequest.post(`/api/non_collateral_vehicle`, {
    carBrandId: data.carBrandId,
    carModelId: data.carModelId,
    manufacturerCountry: data.manufacturerCountry,
    steering: data.steering,
  });
  return res;
};
